import { Redirect } from "react-router-dom"

import { useFlags } from "src/hooks/useFlags"
import { Routes } from "src/router/routes"

export function Inbox() {
  const { enableCompass } = useFlags()

  if (!enableCompass) {
    return <Redirect to={Routes.Dashboard.location().pathname} />
  }

  return <div>This is the inbox</div>
}
